module.exports = function _of(x) { return [x]; };



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/ramda/src/internal/_of.js
// module id = ../../node_modules/ramda/src/internal/_of.js
// module chunks = 18